/**
 * Pure derivation of the "Current Total Data Subjects" MetricCard model for the
 * cookie-module dashboard. Extracted from _dashboard.vue so the "as of" date
 * selection is unit-testable (the admin portal has no wired-up Jest runner; see
 * behavior-options.spec.js for the same pattern). Formatters are injected to keep
 * this module pure and free of Vue / build-alias imports.
 *
 * @param {object|null} dataSubjectCounts - API payload, shape { snapshot, timeSeries }
 * @param {object} formatters - injected formatting helpers
 * @param {(value:number, compact:boolean)=>string} formatters.formatNumber
 * @param {(date:Date, dateFormat:string)=>string} formatters.formatDate
 * @param {string} formatters.dateFormat
 * @returns {Array<object>} zero or one MetricCard descriptor
 */
export function buildDataSubjectMetrics (dataSubjectCounts, { formatNumber, formatDate, dateFormat }) {
	if (!dataSubjectCounts?.snapshot) return []

	const { snapshot } = dataSubjectCounts
	const count = snapshot.identifiedCount || 0

	// "As of" date is the latest completed run, read straight from the snapshot.
	// Do NOT derive it from timeSeries: the API returns runs newest-first
	// (ORDER BY run_finish_utc DESC), so the last array element is the OLDEST run
	// in the window (e.g. the migration backfill), not the most recent.
	const lastCompletedRun = snapshot.lastRunFinish_UTC
	const asOfDate = lastCompletedRun
		? formatDate(new Date(lastCompletedRun), dateFormat)
		: ''

	return [
		{
			title: 'Current Total Data Subjects',
			value: count,
			icon: 'mdi-account-check',
			hasDetailChart: true,
			exactCount: formatNumber(count, false),
			asOfDate
		}
	]
}
